<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.bankNo }}</v-subheader>
        <div class="queryValue" v-for="item in filterBankNoList" :key="item.label">{{ item.label }}</div>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.bankAcctCurr }}</v-subheader>
        <div class="queryValue" v-for="item in filterCurrList" :key="item.label">{{ item.label }}</div>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.bankOrigAmt }}</v-subheader>
        <span class="queryValue">{{ objData.bankOrigAmtAe }} {{ objData.bankOrigAmt }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.bankCharges }}</v-subheader>
        <span class="queryValue">{{ objData.bankCharges }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ objData.bankLocTotalLbl }}</v-subheader>
        <span class="queryValue">{{ objData.bankLocTotal }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.bankTranDate }}</v-subheader>
        <span class="queryValue">{{ objData.bankTranDate }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.paymentMethod }}</v-subheader>
        <div class="queryValue" v-for="item in filterPayementMethodList" :key="item.label">{{ item.label }}</div>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.creditCardNo }}</v-subheader>
        <span class="queryValue">{{ objData.creditCardNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.payerBank }}</v-subheader>
        <div class="queryValue" v-for="item in filterPayerBankList" :key="item.label">{{ item.label }}</div>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.payerCheqNo }}</v-subheader>
        <span class="queryValue">{{ objData.payerCheqNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.cheqNo }}</v-subheader>
        <span class="queryValue">{{ objData.cheqNo }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.printCheq }}</v-subheader>
        <span class="queryValue">{{ objData.printCheq }}</span>
      </v-flex>
      <v-flex md6 xs12>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.payinSlipNo }}</v-subheader>
        <span class="queryValue">{{ objData.payinSlipNo }}</span>
      </v-flex>
      <v-flex md12 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.drawerName }}</v-subheader>
        <span class="queryValue">{{ objData.drawerName }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.glInterface }}</v-subheader>
        <span class="queryValue">{{ objData.glInterface }}</span>
      </v-flex>
      <v-flex md6 xs12>
        <v-subheader class="queryLabel">{{ bankDetLabel.acctPeriod }}</v-subheader>
        <span class="queryValue">{{ objData.acctPeriod }}</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      bankDetLabel: {
        bankNo: 'Bank No.',
        bankAcctCurr: 'Bank Account Currency',
        bankOrigAmt: 'Bank Original Amount',
        bankCharges: 'Bank Charges',
        bankLocTotalLbl: 'Bank Local Total',
        bankTranDate: 'Bank Transaction Date',
        paymentMethod: 'Payment Method',
        creditCardNo: 'Credit Card No.',
        payerBank: 'Payer Bank',
        payerCheqNo: 'Payer Cheque No.',
        cheqNo: 'Cheque No.',
        printCheq: 'Print This Cheque',
        cashBookNo: 'Cash Book No.',
        payinSlipNo: 'Pay-in Slip No.',
        drawerName: 'Drawer Name',
        glInterface: 'GL Interface',
        acctPeriod: 'Accounting Period'
      }
    }
  },
  mounted() {},
  methods: {},
  computed: {
    filterBankNoList() {
      return this.banks.filter((list) => {
        return list.value === this.objData.bankNo
      })
    },
    filterCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.objData.bankAcctCurr
      })
    },
    filterPayementMethodList() {
      return this.paymentmethods.filter((list) => {
        return list.value === this.objData.paymentMethod
      })
    },
    filterPayerBankList() {
      return this.payerbanks.filter((list) => {
        return list.value === this.objData.payerBank
      })
    }
  },
  props: {
    objData: {
      type: Object,
      default: null
    },
    banks: {
      type: Array,
      default: null
    },
    currencies: {
      type: Array,
      default: null
    },
    paymentmethods: {
      type: Array,
      default: null
    },
    payerbanks: {
      type: Array,
      default: null
    }
  }
}
</script>
